import { createEntitySelectorHook } from "../../utils/createEntitySelectorHook";
import { modalSelectors } from "../selectors";
import { TAppModal, TModalsIds } from "../types";

export const useModalSelectors: (id: TModalsIds) => TAppModal =
  createEntitySelectorHook(modalSelectors);
